module.exports = __webpack_public_path__ + "static/hero-lms-be2ab034b559d0076b99461e1f7d60f7.svg";